function getTheme() {
  return process.env.REACT_APP_THEME || process.env.THEME || 'default';
}

export default getTheme;




// WEBPACK FOOTER //
// src/_shared/getTheme.js